import { LifetimeAllowanceClient } from "../../../../../../../../Wrap/Api/Drawdown/LifetimeAllowance";
import { AccountLifetimeAllowanceClient } from "../../../../../../../../Wrap/Api/Account/AccountLifetimeAllowance";
import { RegularCrystallisationClient } from "../../../../../../../../Wrap/Api/Drawdown/RegularCrystallisation";
import { HistoricCrystallisationClient } from "../../../../../../../../Wrap/Api/Drawdown/HistoricCrystallisation";
import { PensionSubAccountSettingsClient } from "../../../../../../../../Wrap/Api/Account/PensionSubAccountSettings";
import { PensionSubAccountSettingsDispatcher } from "../../../../../../Stroes/Variable";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";

export class ProductOverviewCrystallisationAction {
    public static getLifetimeAllowanceDetails(hierarchyId: string, callback) {
        const client = new LifetimeAllowanceClient();
        const promise = client.get(hierarchyId);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }

    public static getAccountLifetimeAllowanceDetails(hierarchyId: string, callback) {
        const client = new AccountLifetimeAllowanceClient();
        const promise = client.get(hierarchyId);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => { });
    }

    public static getRegularCrystallisationDetails(hierarchyId: string, callback) {
        const client = new RegularCrystallisationClient();
        const promise = client.get(hierarchyId);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }

    public static getHistoricCrystallisationDetails(hierarchyId: string, currentPage: number, pageSize: number, callback) {
        const client = new HistoricCrystallisationClient();
        const minRow = (currentPage - 1) * pageSize + 1;
        const maxRow = minRow + pageSize;

        const promise = client.get(hierarchyId, minRow, maxRow);

        promise
            .onSuccess((data) => {
                callback(data);
            })
            .onError(() => {});
    }

    public static loadPensionSubAccountSettings(subAccountHierarchyId: string){
        const client = new PensionSubAccountSettingsClient();
        const promise = client.get(subAccountHierarchyId, true);

        PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((data) => {
            PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
        });

        promise.onError((data) => {
            PensionSubAccountSettingsDispatcher.dispatch({ actionType: ActionType.Error });
        });
    }
}
